import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { ProductBundleOptionsComponentDef } from '@df/catalog-ui/product/bundle-options/product-bundle-options.component.def';
import { BundleOptionSelection } from '@df/catalog/product/bundle-option-selection';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import values from 'lodash-es/values';
import { IfNotTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-not-trade-store.directive';
import { IfTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-trade-store.directive';
import { TradeClassDirective } from 'projects/app-default/src/app/multisite/trade/trade-class.directive';
import { Subscription } from 'rxjs';
import { LocalProduct } from '../../../../model/product/product.decorator';
import { ProductBundleOptionsAttributeComponent } from '../attribute/product-bundle-options-attribute.component';
@Component({
    selector: 'product-bundle-options-list',
    templateUrl: './product-bundle-options-list.component.html',
    styleUrls: ['./product-bundle-options-list.component.scss'],
    standalone: true,
    imports: [
        IfNotTradeStoreDirective,
        IfTradeStoreDirective,
        ImageModule,
        PriceComponent,
        ProductBundleOptionsAttributeComponent,
        ShellComponent,
        TradeClassDirective,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBundleOptionsListComponent extends ProductBundleOptionsComponentDef implements OnInit, OnDestroy {
    private subscriptions: Subscription = new Subscription();
    bundleOptionListings: ProductListing[] = [];
    hoveredColor?: number;
    hoveredIndex?: number;
    override ngOnInit(): void {
        super.ngOnInit();
        this.bundleOptions?.forEach(option => {
            const listing: ProductListing = new ProductListing(
                {},
                option.children.map(children => children.product as Product<IProductDataV2>)?.filter(i => i?.data)
            );
            listing.setAttributeFilters(['color', 'size']);
            this.bundleOptionListings.push(listing);
            this.subscriptions.add(
                listing.subscribe(() => {
                    if (listing.getTotal() === 0) {
                        const sizeFilter = listing.filtersMap['size'] as FilterAttributeOption<any>;
                        const validOption = sizeFilter?.options.find(option => sizeFilter.getCurrentMatchesCount(option));
                        if (validOption && !sizeFilter.isSelected(validOption)) {
                            sizeFilter.select(validOption, true);
                            return;
                        }
                    }
                    option.toggle(option.children.find(child => child.product?.id && child.product.id === listing.models[0]?.id));
                    this.detectChanges();
                })
            );
        });
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    override get bundleOptions(): BundleOptionSelection[] | undefined {
        return this.selection ? values(this.selection.options).filter(i => !!i.children.length) : undefined;
    }
    get hasEditableOptions(): boolean {
        return !!super.bundleOptions?.length;
    }
    defaultFilterSelection(bundleOption: BundleOptionSelection, filterId: string): number | number[] {
        return Object.values(bundleOption.getSelectedProducts())[0]?.product?.data![filterId];
    }
    getSelectedProduct(index: number): LocalProduct<IProductDataV2> | undefined {
        return (
            this.hoveredColor && this.hoveredIndex === index
                ? this.bundleOptionListings[this.hoveredIndex].initModels.find(model => model.data?.color === this.hoveredColor)
                : this.bundleOptionListings[index]?.models[0]
        ) as LocalProduct<IProductDataV2> | undefined;
    }
    getSelectedProductQty(index: number): number {
        let i = index;
        if (this.hoveredColor && this.hoveredIndex === index) {
            i = this.hoveredIndex;
        }
        const product = this.getSelectedProduct(i);
        const bundle = this.bundleOptions[i];
        const child = bundle?.children.find(child => child.id === product?.id);
        return bundle?.selection[child?.selection_id];
    }
    changeColorOnHover(color: number | undefined, listingIndex: number) {
        this.hoveredColor = color;
        this.hoveredIndex = listingIndex;
        this.detectChanges();
    }
}
